import { liveProjects } from "pages/homepage/constants";
import { FC, useEffect, useState } from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";

export const OngoingProjectSection: FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const itemsPerView = 1;
  const totalItems = liveProjects.length;

  const handleScroll = () => {
    if (currentIndex >= 1) {
      setIsScrolling(true);
    } else {
      setIsScrolling(false);
    }
  };

  const handleNext = () => {
    if (currentIndex < totalItems - itemsPerView) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  useEffect(() => {
    handleScroll();
  }, [currentIndex]);
  return (
    <section className="bg-pbg text-blueShades-4">
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col gap-5">
          <div className="flex gap-2 items-center">
            <div className="w-3 h-3 bg-bgreen-0 rounded-full" />
            <p className="text-sm text-blueShades-4 font-SatoshiMedium">
              Ongoing Projects
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-blueShades-4 text-5xl font-SatoshiBold md:w-[520px]">
              Build with confidence{" "}
              <span className="text-ashShade-16">any where in Africa</span>
            </p>
            <div className="hidden md:flex gap-4">
              <button
                className="grid place-items-center  rounded-full w-8 h-8 bg-[#E5EAF0]"
                onClick={handlePrev}
              >
                <TbChevronLeft size={24} />
              </button>
              <button
                className="grid place-items-center rounded-full w-8 h-8 bg-[#76C6F2]"
                onClick={handleNext}
              >
                <TbChevronRight size={24} />
              </button>
            </div>
          </div>

          <div className="md:-mr-16">
            <div className={` w-full ${isScrolling ? "md:-mx-16" : ""}`}>
              <div className="hidden md:block w-full overflow-x-hidden">
                <div
                  className={`flex flex-grow-0 flex-shrink-0 gap-5 lg:transition-transform duration-500`}
                  style={{
                    transform: `translateX(-${currentIndex * 35}%)`,
                  }}
                >
                  {liveProjects.map((project) => {
                    const { id, name, location, img, imgClassName } = project;
                    return (
                      <div
                        key={id}
                        className="relative md:w-[400px] md:min-w-[400px] h-[519px] rounded-xl overflow-hidden"
                      >
                        <img
                          src={img}
                          alt={name}
                          className={`w-full h-full object-cover ${imgClassName ?? ""}`}
                        />
                        <div className="absolute bottom-12 left-4 z-5 text-white capitalize">
                          <p className="font-semibold font-satoshi text-lg">
                            {name}
                          </p>
                          <p className="text-base font-SatoshiMedium">
                            {location}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="block lg:hidden w-full">
            {liveProjects.length > 0 && (
              <div className="relative w-full h-[400px] rounded-xl overflow-hidden">
                <img
                  src={liveProjects[currentIndex].img}
                  alt={liveProjects[currentIndex].name}
                  className={`w-full h-full object-cover ${liveProjects[currentIndex].imgClassName ?? ""}`}
                />
                <div className="absolute bottom-8 left-4 z-5 text-white capitalize">
                  <p className="font-semibold font-satoshi text-lg">
                    {liveProjects[currentIndex].name}
                  </p>
                  <p className="text-base font-SatoshiMedium">
                    {liveProjects[currentIndex].location}
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="flex md:hidden justify-center items-center gap-4">
            <button
              className="grid place-items-center rounded-full w-8 h-8 bg-[#E5EAF0]"
              onClick={handlePrev}
            >
              <TbChevronLeft size={18} />
            </button>
            <span className="text-sm font-semibold font-satoshi">
              {currentIndex + 1} / {totalItems}
            </span>
            <button
              className="grid place-items-center rounded-full w-8 h-8 bg-[#76C6F2]"
              onClick={handleNext}
            >
              <TbChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
